export default __webpack_public_path__ + "static/media/use_action_zc.bab71b3d.png";